module.exports = __webpack_public_path__ + "static/media/callgage-gradient-logo-mobile.d5a7540c.png";